import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { minhasEntrevistas, escolherHorarioEntrevista, pedirOutrosHorarios, cancelarEntrevista } from "../services/api";
import { STATUS_ENTREVISTA } from "../components/AgendarEntrevista";

// 📅 MINHAS ENTREVISTAS (17/10/2026): candidato escolhe o horário, entra na sala, pede outros horários ou cancela;
// a empresa vê todas as entrevistas das vagas dela.
const quando = (iso) => new Date(iso).toLocaleString("pt-BR", { weekday: "long", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export default function EntrevistasPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");
  const carregar = () => minhasEntrevistas().then(setDados).catch((e) => setErro(e.message));
  useEffect(() => {
    if (!user) { navigate("/entrar?redirect=/entrevistas"); return; }
    document.title = "Entrevistas · eaiRH";
    carregar();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!user) return null;
  const faz = async (fn, ok) => { setErro(""); setAviso(""); try { await fn(); setAviso(ok); carregar(); } catch (e) { setErro(e.message); } };
  const lista = dados?.entrevistas || [];
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        <h1 className="text-2xl font-bold text-text">{dados?.ehEmpresa ? "Entrevistas das suas vagas" : "Minhas entrevistas"}</h1>
        <p className="text-sm text-gray-600 mt-1">As entrevistas acontecem na sala de vídeo do eaiRH, direto no navegador. A sala abre 15 minutos antes.</p>
        {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        {aviso && <p className="mt-3 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">{aviso}</p>}
        {dados && lista.length === 0 && (
          <p className="mt-6 text-sm text-gray-500">{dados.ehEmpresa
            ? <>Nenhuma entrevista ainda. Para agendar, abra uma vaga e use <b>📅 Agendar entrevista</b> na lista de candidaturas.</>
            : <>Nenhuma entrevista ainda. Quando uma empresa quiser entrevistar você pelo eaiRH, o convite aparece aqui. <Link to="/vagas" className="text-primary font-semibold">Ver vagas</Link></>}</p>
        )}
        <div className="mt-6 space-y-4">
          {lista.map((e) => {
            const st = STATUS_ENTREVISTA[e.status] || { txt: e.status, cls: "bg-slate-100" };
            return (
              <div key={e.id} className="bg-white rounded-2xl shadow-sm p-5 text-sm">
                <div className="flex flex-wrap items-center gap-2">
                  <b className="text-text">{e.vaga}</b>
                  <span className="text-gray-500">· {dados.ehEmpresa ? e.candidato : e.empresa}</span>
                  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${st.cls}`}>{st.txt}</span>
                </div>
                {e.inicio && e.status !== "proposta" && <div className="text-gray-700 mt-1">{quando(e.inicio)} · {e.duracaoMin} min</div>}
                {e.mensagem && <div className="text-gray-500 italic mt-1">“{e.mensagem}”</div>}
                {!dados.ehEmpresa && e.status === "proposta" && (
                  <div className="mt-3 rounded-xl bg-amber-50 border border-amber-200 p-3">
                    <div className="font-semibold text-amber-900">Escolha um horário{e.prazoEscolha && <> até {quando(e.prazoEscolha)}</>}:</div>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {e.horarios.map((h) => (
                        <button key={h} onClick={() => faz(() => escolherHorarioEntrevista(e.id, h), "Entrevista confirmada! O convite foi para o seu e-mail.")}
                          className="bg-white border border-amber-300 hover:bg-amber-100 rounded-lg px-3 py-1.5 font-semibold">{quando(h)}</button>
                      ))}
                    </div>
                    <button onClick={() => { const r = window.prompt("Nenhum horário serve? Conte à empresa quando você pode (opcional):", ""); if (r !== null) faz(() => pedirOutrosHorarios(e.id, r), "Pedido enviado à empresa."); }}
                      className="text-xs text-amber-800 font-semibold mt-2">Nenhum serve? Pedir outros horários</button>
                  </div>
                )}
                {dados.ehEmpresa && e.status === "proposta" && <div className="text-xs text-gray-500 mt-1">Horários propostos: {e.horarios.map(quando).join(" · ")}</div>}
                <div className="flex flex-wrap gap-2 mt-3">
                  {e.link && <a href={e.link} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar na sala</a>}
                  {dados.ehEmpresa && (e.linksOutros || []).map((o) => (
                    <button key={o.link} onClick={() => navigator.clipboard && navigator.clipboard.writeText(o.link)} className="bg-slate-100 font-semibold rounded-lg px-3 py-1.5 text-xs">📋 Link de {o.nome}</button>
                  ))}
                  {!dados.ehEmpresa && e.status === "confirmada" && e.podeMexer && (
                    <button onClick={() => { const r = window.prompt("Precisa remarcar? Conte à empresa quando você pode:", ""); if (r !== null) faz(() => pedirOutrosHorarios(e.id, r), "Pedido de remarcação enviado à empresa."); }}
                      className="bg-slate-100 font-semibold rounded-lg px-3 py-1.5 text-xs">Pedir remarcação</button>
                  )}
                  {e.podeMexer && <button onClick={() => window.confirm("Cancelar esta entrevista?") && faz(() => cancelarEntrevista(e.id), "Entrevista cancelada.")} className="text-red-600 text-xs font-semibold">Cancelar</button>}
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
